var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrows/down-one"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 6.33334L8 10.3333L4 6.33334H12Z",
    fill: "#1C1B1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.53807 6.142C3.61547 5.95516 3.79778 5.83334 4.00001 5.83334H12C12.2022 5.83334 12.3846 5.95516 12.462 6.142C12.5393 6.32884 12.4966 6.5439 12.3536 6.6869L8.35357 10.6869C8.15831 10.8822 7.84172 10.8822 7.64646 10.6869L3.64646 6.6869C3.50346 6.5439 3.46068 6.32884 3.53807 6.142ZM5.20712 6.83334L8.00001 9.62624L10.7929 6.83334H5.20712Z",
    fill: "#1C1B1E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownFilled);
export default __webpack_public_path__ + "static/media/arrow-down-filled.51e0ab2c68ff016b9109bcccb99eda51.svg";
export { ForwardRef as ReactComponent };